module.exports = __webpack_public_path__ + "img/dateTitleImg.73a0f2ce.png";